/**
 * Utility functions for formatting values in the application
 */

/**
 * Format a number as a locale string with thousands separators
 * @param {number} number - The number to format
 * @param {string} locale - The locale to use for formatting (default: 'en-US')
 * @returns {string} - The formatted number as a string
 */
export const formatNumber = (number, locale = 'en-US') => {
    if (number === null || number === undefined || isNaN(number)) {
        return '-';
    }
    return Number(number).toLocaleString(locale);
};

/**
 * Format a currency value with the specified currency code
 * @param {number} amount - The amount to format
 * @param {string} currencyCode - The currency code (e.g., 'IQD')
 * @param {string} locale - The locale to use for formatting (default: 'en-US')
 * @returns {string} - Formatted currency string (e.g., 'IQD 1,000')
 */
export const formatCurrency = (amount, currencyCode = 'IQD', locale = 'en-US') => {
    if (amount === null || amount === undefined || isNaN(amount)) {
        return '-';
    }
    return `${currencyCode} ${formatNumber(amount, locale)}`;
};
